import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, CheckCircle2, ListTodo } from 'lucide-react';
import { t } from '@/i18n';

// Bridge from the day overview to the work queue.
export const ActionBanner = ({ count }) => {
  if (count === 0) {
    return (
      <div className="flex items-center gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800" data-tour="actions-banner">
        <CheckCircle2 className="h-4 w-4" /> {t('actions.empty')}
      </div>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3" data-tour="actions-banner">
      <ListTodo className="h-5 w-5 text-red-600 shrink-0" />
      <div className="text-sm text-red-900 flex-1 min-w-[12rem]">
        <span className="font-bold">{count}</span> {t('actions.bannerText')}
      </div>
      <Button asChild size="sm" className="gap-1">
        <Link to="/kamiony/akce">{t('actions.open')} <ArrowRight className="h-3.5 w-3.5" /></Link>
      </Button>
    </div>
  );
};
